import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const rolesTicker = ["Property Manager","Sales Agent","BDM","Leasing Consultant","Trust Accountant","Head of PM","Office Manager","General Manager","Sales PA / EA","Marketing Manager","Principal"];
const rolesTicker2 = ["Senior Property Manager","Head of Property Management","Assistant PM","Inspection Manager","Senior Sales Agent","Listing Agent","Buyer's Agent","BDM","Property Manager"];
const rolesTicker3 = ["Sales Manager","Office Manager","Operations Manager","General Manager","Trust Accountant","Sales PA / EA","Reception & Administration","Marketing Manager","Body Corporate Manager","Cadet","Principal"];

const Recruitment = () => {
  const [reg, setReg] = useState({ first:"", last:"", email:"", phone:"", current_role:"", desired_role:"", location:"", about:"" });
  const [regStatus, setRegStatus] = useState({ state:"idle", msg:"" });
  const upd = (k) => (e) => setReg({ ...reg, [k]: e.target.value });
  const submitReg = async (e) => {
    e.preventDefault();
    if (!reg.first || !reg.last || !reg.email) {
      setRegStatus({ state:"error", msg:"Please add your name and email." });
      return;
    }
    setRegStatus({ state:"sending", msg:"Sending…" });
    try {
      await axios.post(`${API}/register`, reg);
      setRegStatus({ state:"success", msg:"Thanks — registration received. Laura will be in touch." });
      setReg({ first:"", last:"", email:"", phone:"", current_role:"", desired_role:"", location:"", about:"" });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setRegStatus({ state:"error", msg: typeof d === "string" ? d : "Something went wrong. Please email laura@peopleology.co directly." });
    }
  };
  return (
    <>
      <section className="hero">
        <div className="hero-bg">RECRUIT</div>
        <span className="eyebrow">Real Estate Recruitment</span>
        <h1>High performers<br />who<br /><em>naturally<br />belong.</em></h1>
        <div className="hero-bottom">
          <p className="hero-sub">We don't post job ads and wait. We headhunt — proactively and persistently — from our established network of real estate professionals across Victoria. Every placement is personal. Every outcome is deliberate.</p>
          <div className="hero-actions">
            <a href="#agencies" className="btn btn-gold">I'm hiring</a>
            <a href="#candidates" className="btn btn-outline">I'm looking</a>
          </div>
        </div>
      </section>

      <div className="ticker-bar">
        <div className="ticker-track">
          {[...rolesTicker,...rolesTicker].map((r,i)=><span key={i} className="ticker-item">{r}</span>)}
        </div>
      </div>

      <div className="audience-split" id="agencies">
        <div className="audience-panel audience-panel-agencies">
          <div>
            <span className="panel-eyebrow-agencies">For Agencies</span>
            <h2 className="panel-title-agencies">Looking<br />to hire?</h2>
            <p className="panel-sub-agencies">We find the people your agency needs to grow — not just candidates who look good on paper, but professionals who fit your culture, your pace and your standards. We do the work so you don't have to.</p>
            <ul className="panel-list panel-list-agencies">
              <li>Active headhunting from our real estate network</li>
              <li>Screening, interviews and reference checks</li>
              <li>Culture-fit and values alignment assessment</li>
              <li>Shortlist of 3–5 pre-qualified candidates</li>
              <li>Offer management and negotiation support</li>
              <li>30/60/90 day onboarding check-ins</li>
              <li>90-day replacement guarantee</li>
            </ul>
            <a href="#fees" className="btn btn-gold">See our fees</a>
          </div>
          <div style={{marginTop:'3rem',paddingTop:'2rem',borderTop:'1px solid var(--border)'}}>
            <p style={{fontSize:'0.72rem',fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',color:'rgba(255,255,255,0.55)',marginBottom:'0.75rem'}}>What agencies say</p>
            <p style={{fontSize:'0.9rem',color:'rgba(255,255,255,0.80)',lineHeight:1.75,fontWeight:300,fontStyle:'italic'}}>“We'd tried three other recruiters. None of them understood what we actually needed. Peoplology got it in the first call.”</p>
            <p style={{fontSize:'0.75rem',color:'var(--gold)',fontWeight:700,marginTop:'0.75rem'}}>Principal — boutique agency, Geelong</p>
          </div>
        </div>

        <div className="audience-panel audience-panel-candidates" id="candidates">
          <div>
            <span className="panel-eyebrow-candidates">For Candidates</span>
            <h2 className="panel-title-candidates">Looking<br />for a role?</h2>
            <p className="panel-sub-candidates">Whether you're actively searching or simply open to the right opportunity — register with Peoplology and we'll keep you front of mind. We won't blast your CV everywhere. We'll match you carefully, and honestly.</p>
            <ul className="panel-list panel-list-candidates">
              <li>A real conversation — not a tick-box intake call</li>
              <li>Matched to roles that genuinely suit you</li>
              <li>Complete confidentiality — always</li>
              <li>Honest advice on the market and your options</li>
              <li>Interview prep and salary negotiation support</li>
              <li>We check in after you start to make sure it's right</li>
            </ul>
            <a href="#register" className="btn-navy-solid">Register with us</a>
          </div>
          <div style={{marginTop:'3rem',paddingTop:'2rem',borderTop:'1px solid rgba(0,0,0,0.15)'}}>
            <p style={{fontSize:'0.72rem',fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',color:'rgba(0,0,0,0.35)',marginBottom:'0.75rem'}}>What candidates say</p>
            <p style={{fontSize:'0.9rem',color:'rgba(0,0,0,0.65)',lineHeight:1.75,fontWeight:300,fontStyle:'italic'}}>“Laura was the first recruiter who actually listened to what I wanted — not just what I'd done. She found me a role I genuinely love.”</p>
            <p style={{fontSize:'0.75rem',color:'var(--navy)',fontWeight:700,marginTop:'0.75rem'}}>Property Manager — Melbourne</p>
          </div>
        </div>
      </div>

      <section className="section section-navy">
        <div className="two-col" style={{marginBottom:'5rem'}}>
          <div>
            <span className="eyebrow">How we recruit</span>
            <h2 style={{fontSize:'clamp(2.5rem,4vw,4rem)',fontWeight:800,color:'var(--white)',lineHeight:0.95,letterSpacing:'-0.04em',marginBottom:'1.5rem'}}>We headhunt.<br />We don't<br /><em style={{fontStyle:'normal',color:'var(--gold)'}}>just post ads.</em></h2>
          </div>
          <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.80)',lineHeight:1.85,fontWeight:300,alignSelf:'end'}}>Most recruiters put up a job ad and wait. We don't. We proactively reach into our network, identify the right people and approach them directly — whether they're actively looking or not. That's how you access the best talent, not just the available talent.</p>
        </div>
        <div>
          {[
            ["01","Discovery — we learn your agency","Before we search for anyone, we understand who you are. Your culture, your values, your pace, your ambitions. We don't fill a role — we find the person who belongs in your team."],
            ["02","We go to market — proactively","We tap our real estate network and approach candidates directly. We're looking for people who are right for you — not people who happened to apply. The best candidates are rarely the ones actively job hunting."],
            ["03","Rigorous screening — we do the work","Every candidate is screened, interviewed and reference checked by Laura before you see them. You receive a shortlist of 3–5 genuinely suitable candidates — not a pile of CVs to wade through."],
            ["04","Offer, onboarding and beyond","We manage the offer, support the negotiation, and check in at 30, 60 and 90 days. We don't disappear after the placement — we're invested in it working."]
          ].map(([n,h,p])=>(
            <div key={n} className="process-row">
              <div className="process-num">{n}</div>
              <div className="process-content"><h3>{h}</h3><p>{p}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="section" style={{background:'var(--navy2)',padding:'100px 5vw 3rem'}}>
        <div style={{maxWidth:'640px',marginBottom:'3rem'}}>
          <span className="eyebrow">Roles we place</span>
          <h2 style={{fontSize:'clamp(2.5rem,4vw,4rem)',fontWeight:800,color:'var(--white)',lineHeight:0.95,letterSpacing:'-0.04em',marginBottom:'1.25rem'}}>Every role.<br />Every level.</h2>
          <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.70)',lineHeight:1.8,fontWeight:300}}>From your first admin hire to a General Manager — we've placed every role in the industry and know exactly what great looks like in each one.</p>
        </div>
      </section>

      <div style={{background:'var(--navy2)',padding:0,overflow:'hidden',whiteSpace:'nowrap',borderTop:'1px solid var(--border)'}} className="ticker-navy">
        <div style={{display:'inline-flex',animation:'tick 40s linear infinite'}}>
          {[...rolesTicker2,...rolesTicker2].map((r,i)=><span key={i} className="ticker-item">{r}</span>)}
        </div>
      </div>
      <div style={{background:'var(--navy2)',padding:0,overflow:'hidden',whiteSpace:'nowrap',borderTop:'1px solid var(--border)'}} className="ticker-navy">
        <div style={{display:'inline-flex',animation:'tick-reverse 40s linear infinite'}}>
          {[...rolesTicker3,...rolesTicker3].map((r,i)=><span key={i} className="ticker-item">{r}</span>)}
        </div>
      </div>
      <div style={{background:'var(--navy2)',height:'48px',borderBottom:'1px solid var(--border)'}}></div>

      <div className="guarantee">
        <h2>90-day placement guarantee.<br /><span>If it doesn't work out, we go again — at no additional cost to you.</span></h2>
        <a href="#fees" className="btn-navy-solid">View our fees</a>
      </div>

      <section className="section section-navy" id="fees">
        <div style={{maxWidth:'640px',marginBottom:'3.5rem'}}>
          <span className="eyebrow">Our fees</span>
          <h2 style={{fontSize:'clamp(2.5rem,4vw,4rem)',fontWeight:800,color:'var(--white)',lineHeight:0.95,letterSpacing:'-0.04em',marginBottom:'1.25rem'}}>Transparent.<br />No surprises.</h2>
          <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.70)',lineHeight:1.8,fontWeight:300}}>Every fee is agreed upfront before any work begins. We operate on a simple two-part structure — an engagement fee to commence the search, and a placement fee on successful hire.</p>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'1px',background:'var(--border)',marginBottom:'1px'}}>
          <div style={{background:'var(--gold)',padding:'3rem'}}>
            <span style={{fontSize:'0.65rem',fontWeight:700,letterSpacing:'0.12em',textTransform:'uppercase',color:'var(--navy)',display:'block',marginBottom:'1rem'}}>Step 1 — To commence</span>
            <div style={{fontSize:'4rem',fontWeight:800,color:'var(--navy)',lineHeight:1,marginBottom:'0.25rem'}}>$2,000</div>
            <div style={{fontSize:'0.85rem',color:'var(--navy2)',marginBottom:'1.5rem',fontWeight:500}}>Engagement fee (ex. GST) · Non-refundable</div>
            <p style={{fontSize:'0.9rem',color:'rgba(0,0,0,0.7)',lineHeight:1.8,fontWeight:300}}>Payable upfront to formally commence your search. This covers Laura's time for the discovery briefing, role profiling, advertising, database search and initial candidate outreach.</p>
            <div style={{marginTop:'1.75rem',paddingTop:'1.75rem',borderTop:'1px solid rgba(0,0,0,0.15)'}}>
              <p style={{fontSize:'0.8rem',color:'rgba(0,0,0,0.55)',fontWeight:400}}>✦ &nbsp;Non-refundable if search is cancelled</p>
              <p style={{fontSize:'0.8rem',color:'rgba(0,0,0,0.55)',fontWeight:400,marginTop:'6px'}}>✦ &nbsp;Credited in full against the placement fee on hire</p>
            </div>
          </div>
          <div style={{background:'var(--navy2)',padding:'3rem'}}>
            <span style={{fontSize:'0.65rem',fontWeight:700,letterSpacing:'0.12em',textTransform:'uppercase',color:'var(--gold)',display:'block',marginBottom:'1rem'}}>Step 2 — On successful placement</span>
            <div style={{fontSize:'4rem',fontWeight:800,color:'var(--white)',lineHeight:1,marginBottom:'0.25rem'}}>15%</div>
            <div style={{fontSize:'0.85rem',color:'rgba(255,255,255,0.70)',marginBottom:'1.5rem'}}>of first-year salary (ex. GST) · Min. $5,000</div>
            <p style={{fontSize:'0.9rem',color:'rgba(255,255,255,0.80)',lineHeight:1.8,fontWeight:300}}>The placement fee is due within 14 days of the candidate's commencement date. The $2,000 engagement fee paid upfront is deducted from this total — so you only pay the balance on hire.</p>
            <div style={{marginTop:'1.75rem',paddingTop:'1.75rem',borderTop:'1px solid var(--border)'}}>
              <p style={{fontSize:'0.8rem',color:'rgba(255,255,255,0.55)',fontWeight:300}}>Example: PM at $75,000 = $11,250 total fee</p>
              <p style={{fontSize:'0.8rem',color:'rgba(255,255,255,0.55)',fontWeight:300,marginTop:'6px'}}>Less $2,000 engagement fee = <strong style={{color:'var(--gold)'}}>$9,250 balance on hire</strong></p>
            </div>
          </div>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'1px',background:'var(--border)'}}>
          {[
            ["01","Pay $2,000 to start","Confirms your commitment and covers the cost of the search. We begin work immediately upon receipt."],
            ["02","We find your person","Shortlist delivered within 2–3 weeks. Pre-screened, reference-checked and ready to interview."],
            ["03","Pay the balance on hire","15% of salary, less the $2,000 already paid. Due within 14 days of your new hire starting."]
          ].map(([n,h,p])=>(
            <div key={n} style={{background:'var(--navy3)',padding:'2rem'}}>
              <div style={{fontSize:'1.8rem',fontWeight:800,color:'var(--gold)',marginBottom:'0.5rem'}}>{n}</div>
              <h4 style={{fontSize:'0.88rem',fontWeight:800,color:'var(--white)',marginBottom:'0.4rem'}}>{h}</h4>
              <p style={{fontSize:'0.8rem',color:'rgba(255,255,255,0.70)',lineHeight:1.65,fontWeight:300}}>{p}</p>
            </div>
          ))}
        </div>

        <div style={{marginTop:'2rem',padding:'1.5rem 2rem',border:'1px solid var(--border)'}}>
          <p style={{fontSize:'0.78rem',color:'rgba(255,255,255,0.55)',lineHeight:1.8,fontWeight:300}}>All fees are exclusive of GST. The $2,000 engagement fee is non-refundable in the event that the search is cancelled by the client after commencement. A minimum placement fee of $5,000 applies. The engagement fee will be credited in full against the placement fee — it does not apply as a credit if the minimum fee threshold applies. The 90-day replacement guarantee applies to all permanent placements.</p>
        </div>
      </section>

      <section className="section section-navy2">
        <div style={{maxWidth:'580px',marginBottom:'3.5rem'}}>
          <span className="eyebrow">What people say</span>
          <h2 style={{fontSize:'clamp(2rem,3.5vw,3.5rem)',fontWeight:800,color:'var(--white)',lineHeight:1,letterSpacing:'-0.04em'}}>Real words.<br />Real results.</h2>
        </div>
        <div className="testi-row">
          {[
            ["Peoplology found us a property manager who was exactly the culture fit we needed. Within a month they were our top performer. They just get it.","Sarah B.","Director — boutique agency, Melbourne"],
            ["Laura was the first recruiter who actually listened to what I wanted — not just what I'd done. She found me a role I genuinely love, at an agency I'm proud to be part of.","Jess M.","Property Manager — placed by Peoplology"],
            ["We'd tried three other recruiters. None of them understood what we actually needed. Peoplology got it in the first call and delivered inside two weeks.","Marcus K.","Principal — independent agency, Geelong"]
          ].map(([t,n,r])=>(
            <div className="testi" key={n}>
              <span className="testi-mark">“</span>
              <p className="testi-text">{t}</p>
              <div className="testi-name">{n}</div>
              <div className="testi-role">{r}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section" style={{background:'var(--navy)'}} id="register">
        <div style={{textAlign:'center',maxWidth:'560px',margin:'0 auto'}}>
          <span className="eyebrow">For candidates</span>
          <h2 style={{fontSize:'clamp(2rem,3.5vw,3.5rem)',fontWeight:800,color:'var(--white)',lineHeight:1,letterSpacing:'-0.04em',marginBottom:'1rem'}}>Register with us.</h2>
          <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.7)',lineHeight:1.8,fontWeight:300}}>Tell us who you are, where you've been, and where you want to go. We'll do the rest — confidentially and without pressure.</p>
        </div>
        <form onSubmit={submitReg} className="form-wrap">
          <div className="form-row">
            <div className="form-group"><label>First name</label><input type="text" placeholder="Jane" value={reg.first} onChange={upd("first")} /></div>
            <div className="form-group"><label>Last name</label><input type="text" placeholder="Smith" value={reg.last} onChange={upd("last")} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Email</label><input type="email" placeholder="jane@email.com" value={reg.email} onChange={upd("email")} /></div>
            <div className="form-group"><label>Phone</label><input type="tel" placeholder="04XX XXX XXX" value={reg.phone} onChange={upd("phone")} /></div>
          </div>
          <div className="form-group"><label>Current role</label><input type="text" placeholder="e.g. Property Manager" value={reg.current_role} onChange={upd("current_role")} /></div>
          <div className="form-group">
            <label>Role you're looking for</label>
            <select value={reg.desired_role} onChange={upd("desired_role")}>
              <option value="">Select a role...</option>
              <option>Property Manager</option>
              <option>Senior Property Manager</option>
              <option>Head of Property Management</option>
              <option>Leasing Consultant</option>
              <option>Sales Agent</option>
              <option>BDM / Business Development</option>
              <option>Office / Operations Manager</option>
              <option>General Manager</option>
              <option>Other</option>
            </select>
          </div>
          <div className="form-group"><label>Where are you based?</label><input type="text" placeholder="e.g. Geelong, VIC" value={reg.location} onChange={upd("location")} /></div>
          <div className="form-group"><label>Tell us about yourself</label><textarea placeholder="What matters to you in your next role? Culture, salary, flexibility, growth? The more you share, the better we can match you." value={reg.about} onChange={upd("about")}></textarea></div>
          <button type="submit" disabled={regStatus.state==="sending"} className="btn-navy-solid" style={{display:'block',textAlign:'center',width:'100%',padding:'16px',opacity:regStatus.state==="sending"?0.7:1,cursor:regStatus.state==="sending"?"wait":"pointer"}}>{regStatus.state==="sending"?"Sending…":"Submit registration"}</button>
          {regStatus.state==="success" && <p style={{textAlign:'center',fontSize:'0.9rem',color:'var(--navy)',marginTop:'1rem',fontWeight:700}}>{regStatus.msg}</p>}
          {regStatus.state==="error" && <p style={{textAlign:'center',fontSize:'0.9rem',color:'#b3261e',marginTop:'1rem',fontWeight:600}}>{regStatus.msg}</p>}
        </form>
      </section>

      <section className="section section-navy" style={{textAlign:'center'}}>
        <span className="eyebrow" style={{display:'block',textAlign:'center',marginBottom:'1.5rem'}}>Ready to find your next hire?</span>
        <h2 style={{fontSize:'clamp(2.5rem,5vw,5rem)',fontWeight:800,color:'var(--white)',letterSpacing:'-0.04em',lineHeight:0.95,marginBottom:'1.5rem'}}>Bold agencies.<br /><em style={{fontStyle:'normal',color:'var(--gold)'}}>Exceptional people.</em></h2>
        <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.70)',fontWeight:300,maxWidth:'440px',margin:'0 auto 3rem',lineHeight:1.8}}>Let's start with a 20-minute conversation. No pressure, no pitch — just an honest discussion about who you need and how we can help you find them.</p>
        <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap'}}>
          <Link to="/contact" className="btn btn-gold">Book a call with Laura</Link>
          <Link to="/" className="btn btn-outline">Back to home</Link>
        </div>
      </section>
    </>
  );
};

export default Recruitment;
